import React from 'react';

const NaibLogo = ({
  showLogo = true,
  showName = true,
  logoClassName = 'h-8 w-8 shrink-0',
  nameClassName = 'h-7 w-auto max-w-[140px]',
  className = '',
  alt = 'Onahiri',
  ...props
}) => {
  return (
    <div
      className={`flex items-center gap-1 ${className}`}
      role="img"
      aria-label={alt}
      {...props}
    >
      {showLogo && (
        <img
          src={`${process.env.PUBLIC_URL}/OnahiriLogo.svg`}
          alt=""
          aria-hidden="true"
          className={`block object-contain rounded-lg ${logoClassName}`}
        />
      )}
      {showName && (
        <img
          src={`${process.env.PUBLIC_URL}/Name.svg`}
          alt={alt}
          className={`block object-contain ${nameClassName}`}
        />
      )}
    </div>
  );
};

export default NaibLogo;
